import { render, staticRenderFns } from "./coaching_recognition.vue?vue&type=template&id=7c19c672&scoped=true&"
import script from "./coaching_recognition.vue?vue&type=script&lang=js&"
export * from "./coaching_recognition.vue?vue&type=script&lang=js&"
import style0 from "./coaching_recognition.vue?vue&type=style&index=0&id=7c19c672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19c672",
  null
  
)

export default component.exports